/** Borderless sticker glyph for REEL&SHORTS context overlays. */

import { artifactMotionClassName } from '@/lib/artifactStickerMotion';

export function artifactStickerKind(text) {
  const raw = String(text || '').trim().toLowerCase();
  if (/comment|koment|kaise comment/.test(raw)) return 'comment';
  if (/like|heart|love|pyaar/.test(raw)) return 'heart';
  if (/share/.test(raw)) return 'share';
  if (/subscribe|bell|follow/.test(raw)) return 'bell';
  return 'burst';
}

function CommentGlyph() {
  return (
    <svg viewBox="0 0 120 120" className="w-full h-full" aria-hidden>
      <path
        fill="#facc15"
        d="M18 16h84a14 14 0 0 1 14 14v48a14 14 0 0 1-14 14H62l-22 22v-22H18A14 14 0 0 1 4 78V30A14 14 0 0 1 18 16z"
      />
      <circle cx="38" cy="55" r="8" fill="#18181b" />
      <circle cx="60" cy="55" r="8" fill="#18181b" />
      <circle cx="82" cy="55" r="8" fill="#18181b" />
    </svg>
  );
}

function HeartGlyph() {
  return (
    <svg viewBox="0 0 120 120" className="w-full h-full" aria-hidden>
      <path
        fill="#f43f5e"
        d="M60 104S14 74 14 44a24 24 0 0 1 46-10 24 24 0 0 1 46 10c0 30-46 60-46 60z"
      />
    </svg>
  );
}

function BurstGlyph() {
  return (
    <svg viewBox="0 0 120 120" className="w-full h-full" aria-hidden>
      <rect x="12" y="12" width="96" height="96" rx="32" fill="#facc15" />
      <circle cx="60" cy="60" r="16" fill="#18181b" />
    </svg>
  );
}

export function ArtifactSticker({
  text = '',
  imageUrl = '',
  mediaKind = 'image',
  animate = true,
  motionStyle = 'thump',
  className = '',
  onMediaSize,
}) {
  const kind = artifactStickerKind(text);
  return (
    <div
      className={`w-full h-full flex items-center justify-center bg-transparent ${artifactMotionClassName(motionStyle, { enabled: animate })} ${className}`}
      data-testid="artifact-sticker-preview"
      data-motion={animate ? motionStyle : 'none'}
    >
      {imageUrl && mediaKind === 'video' ? (
        <video
          src={imageUrl}
          className="max-w-full max-h-full object-contain pointer-events-none select-none"
          autoPlay
          loop
          muted
          playsInline
          onLoadedMetadata={(event) => onMediaSize?.({
            width: event.currentTarget.videoWidth,
            height: event.currentTarget.videoHeight,
          })}
          data-testid="artifact-sticker-video"
        />
      ) : imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          className="max-w-full max-h-full object-contain pointer-events-none select-none"
          draggable={false}
          onLoad={(event) => onMediaSize?.({
            width: event.currentTarget.naturalWidth,
            height: event.currentTarget.naturalHeight,
          })}
          onError={() => onMediaSize?.(null)}
          data-testid="artifact-sticker-image"
        />
      ) : kind === 'comment' ? (
        <CommentGlyph />
      ) : kind === 'heart' ? (
        <HeartGlyph />
      ) : (
        <BurstGlyph />
      )}
    </div>
  );
}
